import moment from "moment";
import swal from "sweetalert";
import history from "../router/history";

export class Util {
    static instance = null;

    static getInstance() {
        if (!Util.instance) {
            Util.instance = new Util();
        }
        return Util.instance;
    }

    specialKeys = [
        "ArrowUp",
        "ArrowLeft",
        "ArrowRight",
        "ArrowDown",
        "Space",
        "CapsLock",
    ];
    accessToken = "ACCESS_TOKEN";
    storeAccessToken = "STORE_ACCESS_TOKEN";

    getAPIURL() {
        let host = process.env.REACT_APP_API_HOST;
        let port = process.env.REACT_APP_API_PORT;
        if (process.env.REACT_APP_ENV === "DEV") {
            host = process.env.REACT_APP_API_DEV_HOST;
            port = process.env.REACT_APP_API_DEV_PORT;
        }

        const rootPath = process.env.REACT_APP_API_ROOT;
        const url = `${host}:${port}/${rootPath}`;
        return url;
    }

    logout(history) {
        localStorage.removeItem(this.accessToken);
        localStorage.removeItem(this.storeAccessToken);
        if (history) {
            history.push("/signin");
        }
    }

    hasNoPermission(action, module) {
        const accessToken = JSON.parse(localStorage.getItem(this.accessToken));

        if (accessToken.isFullAccess) return false;

        const permissions = accessToken.permissions;
        // eslint-disable-next-line
        return (Array.isArray(permissions) && permissions.findIndex((permission) => permission["key"] === action && permission["parentKey"] === module) === -1);
    }

    hasPermission(action, module) {
        const accessToken = JSON.parse(localStorage.getItem(this.accessToken));

        if (accessToken.isFullAccess) return true;

        const permissions = accessToken.permissions;
        // eslint-disable-next-line
        return (Array.isArray(permissions) && permissions.findIndex((permission) => permission["key"] === action && permission["parentKey"] === module) >= 0);
    }

    setAuthSession(data) {
        localStorage.setItem(this.accessToken, JSON.stringify(data));
    }

    getAuthSession() {
        if (!localStorage.getItem(this.accessToken)) return null;
        let result = localStorage.getItem(this.accessToken);
        result = JSON.parse(result);
        return result;
    }

    getBaseUrl() {
        return window.location.origin;
    }

    getAccessToken() {
        const result = this.getAuthSession();
        if (result) return result.accessToken;
        else return null;
    }

    getSetting() {
        const result = this.getAuthSession();
        if (result) return result.setting;
        else return null;
    }

    getCurrentUser() {
        const result = this.getAuthSession();
        if (result)
            return result.profile;
        else
            return {
                fullName: "",
                userName: "",
            };
    }

    getClientId() {
        const result = this.getAuthSession();
        if (result) return result.clientId;
        else return null;
    }

    getClientLogo() {
        const result = this.getSetting();
        if (result) return result.logo;
        else return null;
    }

    getCurrentDate() {
        return moment();
    }

    getCurrentTime() {
        return new moment().format("HH:mm");
    }

    getTimeClock(time) {
        const fixDate = "2000-01-01";
        if (time) return moment(`${fixDate} ${time}`).format("hh:mm A");
        return "";
    }

    formatTimePicker(time) {
        return moment(time).format("HH:mm:ss");
    }

    formatDate(value, format = "DD/MM/YYYY") {
        format = format === null || format === "" ? "DD MMM YYYY" : format;
        return moment(value).format(format);
    }

    formatDateTime(value, format = "DD MMMM YYYY h:mm:ss A") {
        format = format == null ? "DD MMMM YYYY h:mm:ss A" : format;
        return moment(value).format(format);
    }

    formatDateForMYSQL(value, format = "YYYY-MM-DD") {
        format = format == null ? "YYYY-MM-DD" : format;
        value = moment(value).format(format);
        return value;
    }

    formatPhoneNumber(phoneNumberString) {
        if (phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (phoneNumberString.length === 9) {
                match = cleaned.match(/^(\d{3})(\d{3})(\d{3})$/);
            }

            if (match) {
                return match[1] + " " + match[2] + " " + match[3];
            }
        }

        return phoneNumberString;
    }

    formatCurrency(n, symbol = "") {
        // eslint-disable-next-line
        let unsigne = "";
        if (n < 0) {
            n = Math.abs(n);
            unsigne = "-";
        }
        // 0: BEFORE, 1: AFTER
        let result = parseFloat(n)
            .toFixed(2)
            .replace(/./g, function (c, i, a) {
                return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
            });

        return `${symbol}${result}`;
    }

    formatCurrencyKHR(n) {
        // eslint-disable-next-line
        let unsigne = "";
        if (n < 0) {
            n = Math.abs(n);
            unsigne = "-";
        }
        // 0: BEFORE, 1: AFTER
        let result = parseFloat(n)
            .toFixed(2)
            .replace(/./g, function (c, i, a) {
                return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
            })
            .replace(/\.0+$/, '');

        return result;
    }

    getDomainInfo() {
        const full = window.location.host;
        //window.location.host is subdomain.domain.com
        const parts = full.split(".");
        let sub = parts[0];
        let domain = parts[1];
        const type = parts[2];
        if (type != null) {
            domain = `${domain}.${type}`;
        }
        const protocol = window.location.protocol.replace(/:/g, "");
        sub = "greenmall";
        let subdomain = `${protocol}://${sub}.${domain}`;
        if (type != null) {
            subdomain = `${subdomain}.${type}`;
        }
        return {
            domain: `${protocol}://${domain}`,
            subdomain,
            subStr: sub,
            domainStr: domain,
            protocolStr: protocol,
        };
    }

    getImageFromSpace(fileName) {
        return `${process.env.REACT_APP_RESOURCE_HOST}${fileName}`;
    }

    /**
     * When user need to push filter params to URL
     * @param {*} pathname
     * @param {*} qryStr
     */
    pushParamsToURL(pathname, qryStr) {
        history.push({
            pathname,
            search: qryStr,
        });
    }

    /**
     * Sweetalertjs, function display messaage
     * @param {*} title
     * @param {*} icon
     */
    sweetAlertMessage(title = "", icon = "") {
        return swal(title, {
            buttons: false,
            icon,
            timer: 2000,
        });
    }

    sweetAlertConfirm(title, text, buttons = ["Cancel", "Yes"]) {
        return swal({
            title,
            text,
            icon: "warning",
            buttons,
            dangerMode: true,
        });
    }

    getFristCharater = (value) => {
        if (value) {
            const splitString = value.split(" ");
            const filter = splitString.filter(value => value !== "");
            if (filter.length >= 2) {
                const lastIndex = filter.length - 1;
                const result = `${filter[0][0]}${filter[lastIndex][0]}`
                return result.toUpperCase();
            }
            if (filter.length === 1) {
                return filter[0][0].toUpperCase();
            }
        }
        return "";

    };

    subscribeEvent = (eventName, listener) => {
        document.addEventListener(eventName, listener);
    };

    unsubscribeEvent = (eventName, listener) => {
        document.removeEventListener(eventName, listener);
    };

    publishEvent = (eventName, data) => {
        const event = new CustomEvent(eventName, { data });
        document.dispatchEvent(event);
    };

    covertMinutesToHoursAndMinutes = (totalMinutes) => {
        const minutes = parseInt(totalMinutes % 60);
        const hours = Math.floor(totalMinutes / 60);

        return `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}`;
    };
}
